import "./AppHeader.scss";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { getAppContext } from "config/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faUser } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ButtonDropdown from "components/common/button-dropdown/ButtonDropdown";
import Translate from "components/common/Translate";
import ThemeSwitcher from "./partials/ThemeSwitcher";
import LanguageSwitcher from "./partials/LanguageSwitcher";
import { Link, useLocation } from "react-router-dom";
import { AppRoutes } from "config/router";
import useAppContext from "utilities/hooks/useAppContext";

const APP_NAV_MENU_HASH = '#menu'

const AppHeader = () => {
	const context = getAppContext(useContext);
	const [t] = useTranslation();

	const accountButton = (
		<>
			<span>{context.user.name}</span>
			<span>&nbsp;</span>
			<span>&nbsp;</span>
			<FontAwesomeIcon style={{ fontSize: '20px' }} icon={faUser} />
		</>
	);

	return (
		<header className="app-header">
			<div className="app-header_section float-right ">
				<LanguageSwitcher />
				<ThemeSwitcher />
				<ButtonDropdown button={accountButton} className="my-auto">
					<ul>
						<li>
							<Link to={AppRoutes.PROFILE}>{t("profile")}</Link>
						</li>
						<li>
							<hr />
						</li>
						<li>
							<Link to={AppRoutes.DEMO}>Demo</Link>
						</li>
						<li>
							<a href="/graphql" target="_blank">
								GraphQL
							</a>
						</li>
						<li>
							<a href="/graphql?sdl" target="_blank">
								GraphQL <FontAwesomeIcon icon={faDownload} />
							</a>
						</li>
						<li>
							<hr />
						</li>
						<li>
							<a title="logout" href="/auth/logout">
								<Translate i18nKey="logout" />
							</a>
						</li>
					</ul>
				</ButtonDropdown>
			</div>
			<div className="app-header_section float-left">
				<Checkbox />
				<Link to="/" className="flex gap-2">
					<img
						className="logo main"
						src="/assets/images/logo-main.svg"
						alt="logo-main"
					/>
					<img
						className="logo text"
						src="/assets/images/logo-text.svg"
						alt="logo-text"
					/>
				</Link>
			</div>
		</header>
	);
};

export default AppHeader;

const Checkbox = () => {
	const context = useAppContext();
	const location = useLocation();
	const style = {
		fontSize: "12px",
		margin: 'auto'
	};

	const [isOpen, setIsOpen] = useState<boolean>(false)

	const onChange = (event: ChangeEvent<HTMLInputElement>) => {
		setIsOpen(event.target.checked);
		context.navigate(APP_NAV_MENU_HASH);
	}

	useEffect(() => {
		setIsOpen(location.hash.endsWith(APP_NAV_MENU_HASH));
	}, [location])

	return (
		<>
			<StyledWrapper style={style} className="md:hidden">
				<label className="hamburger">
					<input title="open" checked={isOpen} onChange={onChange} type="checkbox" />
					<svg viewBox="0 0 32 32">
						<path
							className="line line-top-bottom"
							d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22"
						/>
						<path className="line" d="M7 16 27 16" />
					</svg>
				</label>
			</StyledWrapper>
		</>
	);
};

const StyledWrapper = styled.div`
  .hamburger {
    cursor: pointer;
  }

  .hamburger input {
    display: none;
  }

  .hamburger svg {
    /* The size of the SVG defines the overall size */
    height: 3em;
    /* Define the transition for transforming the SVG */
    transition: transform 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .line {
    fill: none;
    stroke: ${window.matchMedia('(prefers-color-scheme: dark)').matches ? 'white' : 'black'};
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 3;
    /* Define the transition for transforming the Stroke */
    transition: stroke-dasharray 600ms cubic-bezier(0.4, 0, 0.2, 1),
      stroke-dashoffset 600ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .dark .line {
    stroke: white;
  }

  .line-top-bottom {
    stroke-dasharray: 12 63;
  }

  .hamburger input:checked + svg {
    transform: rotate(-45deg);
  }

  .hamburger input:checked + svg .line-top-bottom {
    stroke-dasharray: 20 300;
    stroke-dashoffset: -32.42;
  }
`;
